import * as Sentry from '@sentry/vue'
import { computed } from 'vue'
import store from '../store'

import { useFeedbackButtonVisibility } from '@/composables/useFeedbackButtonVisibility'
import type { ActorComponent } from 'node_modules/@sentry-internal/feedback/build/npm/types/core/components/Actor'

export const useSentryFeedback = () => {
    const currentUser = computed(() => store.state.users.currentUser)

    const { toggleFeedbackButton } = useFeedbackButtonVisibility()

    const feedback = Sentry.getFeedback()
    if (!feedback) return

    let widget: ActorComponent | null = null

    const isAuthenticated = () => {
        return currentUser.value !== null
    }

    const updateFeedbackWidget = () => {
        if (isAuthenticated() && !widget) {
        widget = feedback.createWidget()
        widget.appendToDom()
        toggleFeedbackButton()
        if (currentUser.value?.email) {
            Sentry.setUser({
                username: currentUser.value.first_name ?? '',
                email: currentUser.value.email ?? ''
            })
        }
        } else if (!isAuthenticated() && widget) {
            widget.removeFromDom()
            widget = null
            Sentry.setUser(null)
        }
    }
    updateFeedbackWidget()
    store.subscribe((mutation: any, state: any) => {
        if (mutation.type === 'users/SET_CURRENT_USER') {
            updateFeedbackWidget()
        }
    })
}